import { DateInput } from "@blueprintjs/datetime";
import * as React from "react";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";

interface MonthPickerProps {
  onChange: (val: Date) => void;
  value: Date;
}

interface MonthPickerState {
}

export class MonthPicker
  extends React.Component<MonthPickerProps, MonthPickerState>
{
  render() {
    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <DateInput
        {...getMomentFormatter("DD/MM/YYYY")}
        locale="pt-br"
        dayPickerProps={dayPickerProps}
        placeholder="DD/MM/AAAA"
        onChange={this.props.onChange}
        value={this.props.value}
        canClearSelection={false}
      />
    );
  }
}
